var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaminho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1225",
    "data-name": "Grupo 1225",
    transform: "translate(107 7703)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "circleIconState",
    id: "Elipse_89",
    "data-name": "Elipse 89",
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    transform: "translate(-107 -7703)",
    fill: "#7e73f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1221",
    "data-name": "Grupo 1221",
    transform: "translate(-465.374 -7882.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_880",
    "data-name": "Caminho 880",
    d: "M386.3,190.7l9.859,9.859-9.859,9.859v-5.408H375.032l3.709-8.9H386.3Z",
    transform: "translate(-0.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_881",
    "data-name": "Caminho 881",
    d: "M370.918,205.081h-8.544l3.709-8.544h8.544Z",
    transform: "translate(0 -0.425)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaminho);
export default __webpack_public_path__ + "static/media/A caminho.b18f3eae87e2b94c6459863dcd5b4f13.svg";
export { ForwardRef as ReactComponent };